import React, { useState, useEffect, useRef, useContext } from 'react';
import CloudUpload from '@mui/icons-material/CloudUploadOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { STATIC_ICONS } from '../Constants';
import { LanguageContext } from '../context/LanguageContext';
import commonTranslations from '../languages/common.json';


const BackgroundImageSettings = ({ onFileChanged, initialFile = null, initialUrl = null }) => {
  const { lang } = useContext(LanguageContext);
  const t = commonTranslations[lang].common.backgroundImageSettings;

  const [file, setFile] = useState(initialFile);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isDeleted, setIsDeleted] = useState(false);
  const onFileChangedRef = useRef(onFileChanged);

  useEffect(() => {
    onFileChangedRef.current = onFileChanged;
  }, [onFileChanged]);

  useEffect(() => {
    if ((file instanceof Blob || file === null) && typeof onFileChangedRef.current === 'function') {
      onFileChangedRef.current(file);
    }
  }, [file]);

  useEffect(() => {
    if (file instanceof Blob) {
      const objectUrl = URL.createObjectURL(file);
      setPreviewUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else if (typeof file === 'string' && file.trim().length > 0) {
      const normalized = file.trim();
      const isAbsolute = /^blob:|^data:|^https?:/i.test(normalized);
      setPreviewUrl(isAbsolute ? normalized : (STATIC_ICONS + normalized));
    } else if (initialUrl && !isDeleted) {
      setPreviewUrl(STATIC_ICONS + initialUrl);
    } else {
      setPreviewUrl(null);
    }
  }, [file, initialUrl, isDeleted]);

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0]);
      setIsDeleted(false);
    }
  };

  const handleDelete = () => {
    setFile(null);
    setIsDeleted(true);
  };

  return (
    <div className="edit-content-part" style={{ flex: 0.65 }}>
      <label>{t.label}</label>
      <div
        className="edit-form-item"
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <input
          type="file"
          accept="image/*"
          className="edit-logo-section"
          title=""
          onChange={handleFileChange}
        />

        {previewUrl ? (
          <>
            <img
              src={previewUrl}
              alt=""
              onClick={handleDelete}
              style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '200px' }}
            />
            <DeleteIcon onClick={handleDelete} style={{ cursor: 'pointer' }} />
          </>
        ) : (
          <>
            <CloudUpload
              style={{
                position: 'absolute',
                top: '15%',
                pointerEvents: 'none',
                color: 'var(--accent)',
                transform: 'scale(2.5)',
              }}
            />
            <div
              style={{
                position: 'absolute',
                pointerEvents: 'none',
                fontWeight: 500,
              }}
            >
              {t.uploadText}
            </div>
            <div
              style={{
                position: 'absolute',
                left: '5%',
                bottom: '15%',
                pointerEvents: 'none',
              }}
              className="edit-helper"
            >
              {t.uploadHelper}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BackgroundImageSettings;
